// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"597":"273d3a17","687":"cd08c3cc","787":"8bc55c8c"}[chunkId] + ".chunk.js";
};